export default "__VITE_ASSET__98KoUL5E__"